(() => {
  if (window.__vaenFacetsInstalled) return;
  window.__vaenFacetsInstalled = true;

  const openState = window.__vaenFacetOpenState || new Map();
  window.__vaenFacetOpenState = openState;

  const order = ['table type','material','color / finish','shape','seating capacity','width','ready to ship','price','availability'];
  const swatches = {
    'off white':'#f2eee5','off-white':'#f2eee5','ivory':'#f1eadb','sand':'#d2cabd','arena':'#c8b9a4','gray':'#9e9e99','grey':'#9e9e99','black':'#171717','natural oak':'#b48b62','walnut':'#694a36','cherry':'#80503a','dark oak':'#302521','white beech':'#d7ae7d','stainless steel satin':'#bcbdbd','stainless steel mirror':'#e0e1e1','carpets':'#918174'
  };

  const clean = (value = '') => value.toLowerCase().replace(/^filter\s*[—–-]\s*/,'').replace(/\s+/g,' ').trim();
  const getLabel = (item) => clean(item.querySelector('.facets__label')?.textContent || '');

  function rememberDetails(item) {
    const details = item.querySelector('details.facets__panel');
    if (!details) return;
    const key = getLabel(item);
    if (!key) return;
    item.dataset.vaenFacetKey = key;
    if (!details.dataset.vaenStateReady) {
      if (openState.has(key)) details.open = openState.get(key);
      else details.open = false;
      details.addEventListener('toggle', () => openState.set(key, details.open));
      details.dataset.vaenStateReady = 'true';
    }
  }

  function decorateFinish(item) {
    if (getLabel(item) !== 'color / finish') return;
    item.classList.add('vaen-facet--finish');
    item.querySelectorAll('.checkbox__label-text').forEach((text) => {
      if (text.parentElement?.querySelector('.vaen-filter-swatch')) return;
      const name = clean(text.textContent);
      const dot = document.createElement('span');
      dot.className = 'vaen-filter-swatch';
      dot.style.setProperty('--vaen-swatch', swatches[name] || '#d4d0c8');
      dot.setAttribute('aria-hidden', 'true');
      text.before(dot);
    });
  }

  function sortFilters(wrapper) {
    const items = [...wrapper.children].filter((el) => el.querySelector?.('.facets__label'));
    items.sort((a,b) => {
      const ai = order.indexOf(getLabel(a));
      const bi = order.indexOf(getLabel(b));
      return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
    });
    items.forEach((item) => wrapper.appendChild(item));
  }

  function enhance() {
    document.querySelectorAll('.facets--drawer .facets__filters-wrapper').forEach((wrapper) => {
      [...wrapper.children].filter((el) => el.querySelector?.('.facets__label')).forEach((item) => {
        rememberDetails(item);
        decorateFinish(item);
      });
      sortFilters(wrapper);
    });
  }

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once:true });
  else enhance();

  new MutationObserver(schedule).observe(document.documentElement, { childList:true, subtree:true });
  document.addEventListener('shopify:section:load', schedule);
})();